/**
 * Маппинг реальных статусов кампаний в упрощенные для отображения
 * @param {string|null|undefined} status - Реальный статус из БД
 * @returns {string} Упрощенный статус: 'active', 'paused', 'finished', 'moderation'
 */
export function mapCampaignStatus(status) {
    // Support passing either a status string OR an object { user_status, system_status, status }.
    if (status && typeof status === 'object') {
        const user = status.user_status;
        const system = status.system_status;
        if (user === 'paused') return 'paused';
        if (user === 'draft') return 'draft';
        if (system) return String(system).toLowerCase().trim();
        // Fallback to `status` field on object
        status = status.status;
    }

    if (!status) {
        return 'moderation';
    }

    const statusLower = String(status).toLowerCase().trim();

    // Активна
    const activeStatuses = [
        'active',
        'activated',
        'booked',
        'approve',
        'approved',
        'running',
        'processing',
        'reserve',
    ];

    // На паузе
    const pausedStatuses = [
        'paused',
        'pause',
    ];

    // Черновик
    const draftStatuses = [
        'draft',
    ];

    // Закончена
    const finishedStatuses = [
        'completed',
        'finished',
        'ended',
        'cancelled',
        'cancel',
        'archived',
        'closed',
    ];

    // На модерации
    const moderationStatuses = [
        'pending_approval',
        'pending',
        'review',
        'rejected',
        'reject',
    ];

    if (activeStatuses.includes(statusLower)) {
        return 'active';
    }

    if (pausedStatuses.includes(statusLower)) {
        return 'paused';
    }

    if (draftStatuses.includes(statusLower)) {
        return 'draft';
    }

    if (finishedStatuses.includes(statusLower)) {
        return 'finished';
    }

    if (moderationStatuses.includes(statusLower)) {
        return 'moderation';
    }

    // По умолчанию - модерация
    return 'moderation';
}

/**
 * Получить label для упрощенного статуса
 * @param {string} displayStatus - Упрощенный статус
 * @returns {string} Текстовый label
 */
export function getCampaignStatusLabel(displayStatus) {
    const labels = {
        'active': 'Активна',
        'paused': 'Приостановлена',
        'draft': 'Черновик',
        'completed': 'Завершена',
        'finished': 'Завершена', // Для обратной совместимости
        'moderation': 'На модерации',
        'rejected': 'Отклонена',
        'exhausted': 'Лимит исчерпан',
    };

    return labels[displayStatus] || 'Unknown';
}

/**
 * Получить display status и label для кампании
 * @param {string|null|undefined} status - Реальный статус из БД
 * @returns {{displayStatus: string, displayLabel: string}}
 */
export function getCampaignDisplayStatus(status) {
    const displayStatus = mapCampaignStatus(status);
    const displayLabel = getCampaignStatusLabel(displayStatus);
    return { displayStatus, displayLabel };
}
